/* ==========================================================================
   TRIBUNE — comportements des sections personnalisées
   Chargé en « defer ». Chaque composant est repéré par data-tb="…" et
   initialisé une seule fois (compatible avec l'éditeur de thème).
   ========================================================================== */
(function () {
  'use strict';

  var docEl = document.documentElement;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO = 'IntersectionObserver' in window;

  function $$(selector, root) { return Array.prototype.slice.call((root || document).querySelectorAll(selector)); }
  function once(el, key) { var k = '__tb_' + key; if (el[k]) { return false; } el[k] = true; return true; }
  function raf(fn) { return window.requestAnimationFrame(fn); }
  function safePlay(video) { var p = video.play(); if (p && p.catch) { p.catch(function () {}); } }
  function onVisible(el, cb, opts) {
    if (!hasIO) { cb(true); return null; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { cb(e.isIntersecting, e); });
    }, opts || { threshold: 0.25 });
    io.observe(el);
    return io;
  }

  /* ----------------------------------------------------------------------
     Apparition au scroll
     ---------------------------------------------------------------------- */
  var revealIO = null;
  function initReveal(root) {
    if (!hasIO || reduceMotion) {
      $$('[data-tb-reveal]', root).forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    if (!revealIO) {
      revealIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); revealIO.unobserve(e.target); }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    }
    $$('[data-tb-stagger]', root).forEach(function (group) {
      $$('[data-tb-reveal]', group).forEach(function (child, i) { child.style.setProperty('--tb-i', i); });
    });
    $$('[data-tb-reveal]', root).forEach(function (el) {
      if (once(el, 'reveal')) { revealIO.observe(el); }
    });
  }

  /* ----------------------------------------------------------------------
     Piste défilante générique (flèches + barre de progression + boucle)
     ---------------------------------------------------------------------- */
  function trackStep(track) {
    var first = track.firstElementChild;
    if (!first) { return track.clientWidth; }
    var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
    return first.getBoundingClientRect().width + gap;
  }
  function trackNext(track) {
    var max = track.scrollWidth - track.clientWidth;
    if (track.scrollLeft + 4 >= max) { track.scrollTo({ left: 0, behavior: 'smooth' }); }
    else { track.scrollBy({ left: trackStep(track), behavior: 'smooth' }); }
  }
  function trackPrev(track) {
    if (track.scrollLeft <= 4) { track.scrollTo({ left: track.scrollWidth, behavior: 'smooth' }); }
    else { track.scrollBy({ left: -trackStep(track), behavior: 'smooth' }); }
  }
  function bindTrack(root, track) {
    var prev = root.querySelector('[data-tb-prev]');
    var next = root.querySelector('[data-tb-next]');
    var bar = root.querySelector('.tb-progress span');
    if (prev) { prev.addEventListener('click', function () { trackPrev(track); root.dispatchEvent(new CustomEvent('tb:interact')); }); }
    if (next) { next.addEventListener('click', function () { trackNext(track); root.dispatchEvent(new CustomEvent('tb:interact')); }); }
    if (bar) {
      var sync = function () {
        var scrollable = track.scrollWidth - track.clientWidth;
        var w = Math.max(12, Math.min(100, (track.clientWidth / Math.max(track.scrollWidth, 1)) * 100));
        var pos = scrollable > 0 ? track.scrollLeft / scrollable : 0;
        bar.style.width = w + '%';
        bar.style.transform = 'translateX(' + (pos * (100 - w) / w * 100) + '%)';
      };
      track.addEventListener('scroll', function () { raf(sync); }, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    }
  }

  /* ----------------------------------------------------------------------
     Héro mobile (carrousel)
     ---------------------------------------------------------------------- */
  function initHero(root) {
    var track = root.querySelector('.tb-hero__track');
    var slides = $$('.tb-hero__slide', root);
    var dots = $$('.tb-hero__dot', root);
    if (!track || slides.length < 2) { if (slides[0]) { slides[0].classList.add('is-active'); } return; }

    var DELAY = parseInt(root.getAttribute('data-delay'), 10) || 5500;
    var RESUME = 8000;
    var idx = 0, timer = null, idleTimer = null, inView = true;
    root.style.setProperty('--tb-delay', DELAY + 'ms');

    function setActive(i) {
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
      dots.forEach(function (d, k) {
        var on = k === i;
        d.classList.remove('is-on');
        if (on) { void d.offsetWidth; d.classList.add('is-on'); }
        d.setAttribute('aria-current', on ? 'true' : 'false');
      });
    }
    function goTo(i, instant) {
      idx = (i + slides.length) % slides.length;
      track.scrollTo({ left: idx * track.clientWidth, behavior: (instant || reduceMotion) ? 'auto' : 'smooth' });
      setActive(idx);
    }
    function start() {
      if (reduceMotion || timer || !inView || document.hidden) { return; }
      root.classList.remove('is-paused');
      timer = window.setInterval(function () { goTo(idx + 1); }, DELAY);
    }
    function stop() { if (timer) { window.clearInterval(timer); timer = null; } }
    function hold() {
      stop();
      root.classList.add('is-paused');
      window.clearTimeout(idleTimer);
      idleTimer = window.setTimeout(function () { setActive(idx); start(); }, RESUME);
    }

    var scrollTick = false;
    track.addEventListener('scroll', function () {
      if (scrollTick) { return; }
      scrollTick = true;
      raf(function () {
        scrollTick = false;
        var i = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
        if (i !== idx && i >= 0 && i < slides.length) { idx = i; setActive(i); }
      });
    }, { passive: true });
    ['pointerdown', 'touchstart'].forEach(function (ev) { track.addEventListener(ev, hold, { passive: true }); });
    dots.forEach(function (d, k) { d.addEventListener('click', function () { hold(); goTo(k); }); });
    document.addEventListener('visibilitychange', function () { if (document.hidden) { stop(); } else { start(); } });
    onVisible(root, function (visible) { inView = visible; if (visible) { start(); } else { stop(); } }, { threshold: 0.3 });
    window.addEventListener('resize', function () { goTo(idx, true); });

    root.classList.add('is-ready');
    setActive(0);
    if (!hasIO) { start(); }
  }

  /* ----------------------------------------------------------------------
     Vidéos verticales : chargement paresseux + lecture à l'écran + son
     ---------------------------------------------------------------------- */
  function initVids(root) {
    var track = root.querySelector('.tb-track');
    var cards = $$('.tb-vids__card', root);
    if (track) { bindTrack(root, track); }

    function load(card) {
      var v = card.querySelector('video');
      if (!v || v.getAttribute('src')) { return v; }
      var src = v.getAttribute('data-src');
      if (!src) { return v; }
      var ready = function () { card.classList.add('is-loaded'); };
      v.addEventListener('loadeddata', ready, { once: true });
      v.addEventListener('playing', ready, { once: true });
      v.addEventListener('error', function () { card.classList.add('is-loaded', 'is-error'); }, { once: true });
      v.preload = 'metadata';
      v.src = src;
      return v;
    }

    if (hasIO) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var card = e.target;
          if (e.isIntersecting) { load(card); }
          var v = card.querySelector('video');
          if (!v) { return; }
          if (e.isIntersecting && e.intersectionRatio >= 0.5 && !card.classList.contains('is-paused')) { safePlay(v); }
          else if (!v.paused) { v.pause(); }
        });
      }, { threshold: [0, 0.5], rootMargin: '250px 150px' });
      cards.forEach(function (c) { io.observe(c); });
    } else {
      cards.forEach(function (c) { var v = load(c); if (v) { safePlay(v); } });
    }

    cards.forEach(function (card) {
      var v = card.querySelector('video');
      var btn = card.querySelector('.tb-vids__sound');
      if (!v) { return; }
      if (btn) {
        btn.addEventListener('click', function (ev) {
          ev.stopPropagation();
          var enable = v.muted;
          cards.forEach(function (other) {
            var ov = other.querySelector('video');
            if (ov) { ov.muted = true; }
            other.classList.remove('has-sound');
            var ob = other.querySelector('.tb-vids__sound');
            if (ob) { ob.setAttribute('aria-pressed', 'false'); }
          });
          if (enable) {
            load(card);
            v.muted = false;
            card.classList.add('has-sound');
            btn.setAttribute('aria-pressed', 'true');
            safePlay(v);
          }
        });
      }
      v.addEventListener('click', function () {
        load(card);
        if (v.paused) { card.classList.remove('is-paused'); safePlay(v); }
        else { v.pause(); card.classList.add('is-paused'); }
      });
    });
  }

  /* ----------------------------------------------------------------------
     Avis (cartes) : défilement auto quand visible + « Voir plus »
     ---------------------------------------------------------------------- */
  function initRvc(root) {
    var track = root.querySelector('.tb-track');
    if (!track) { return; }
    bindTrack(root, track);
    var timer = null, inView = false, held = false, holdTimer = null;
    var DELAY = parseInt(root.getAttribute('data-delay'), 10) || 4000;

    function start() { if (reduceMotion || timer || !inView || held) { return; } timer = window.setInterval(function () { trackNext(track); }, DELAY); }
    function stop() { if (timer) { window.clearInterval(timer); timer = null; } }
    function hold() { held = true; stop(); window.clearTimeout(holdTimer); holdTimer = window.setTimeout(function () { held = false; start(); }, 7000); }

    root.addEventListener('mouseenter', function () { held = true; stop(); });
    root.addEventListener('mouseleave', function () { held = false; start(); });
    track.addEventListener('touchstart', hold, { passive: true });
    track.addEventListener('pointerdown', hold, { passive: true });
    root.addEventListener('tb:interact', hold);
    onVisible(root, function (v) { inView = v; if (v) { start(); } else { stop(); } }, { threshold: 0.3 });

    $$('.tb-rvc__more', root).forEach(function (btn) {
      var card = btn.closest('.tb-rvc__card');
      var text = card && card.querySelector('.tb-rvc__text');
      if (!text) { return; }
      var check = function () { btn.hidden = text.scrollHeight - 2 <= text.clientHeight && !card.classList.contains('is-expanded'); };
      check();
      window.addEventListener('load', check);
      btn.addEventListener('click', function () {
        var open = card.classList.toggle('is-expanded');
        btn.textContent = open ? (btn.getAttribute('data-less') || 'Voir moins') : (btn.getAttribute('data-more') || 'Voir plus');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        hold();
      });
    });
  }

  /* ----------------------------------------------------------------------
     Mini-slider d'avis (fondu, hauteur fixe)
     ---------------------------------------------------------------------- */
  function initReviewSlider(root) {
    var cards = $$('.tb-rs__card', root);
    if (cards.length < 2) { if (cards[0]) { cards[0].classList.add('is-active'); } return; }
    var dotsWrap = root.querySelector('.tb-rs__dots');
    var dots = [];
    if (dotsWrap) {
      cards.forEach(function () { var s = document.createElement('span'); dotsWrap.appendChild(s); dots.push(s); });
    }
    var current = 0, timer = null, inView = false;
    var DELAY = parseInt(root.getAttribute('data-delay'), 10) || 5000;

    function show(i) {
      cards[current].classList.remove('is-active');
      current = (i + cards.length) % cards.length;
      cards[current].classList.add('is-active');
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === current); });
    }
    function start() { if (reduceMotion || timer || !inView) { return; } timer = window.setInterval(function () { show(current + 1); }, DELAY); }
    function stop() { if (timer) { window.clearInterval(timer); timer = null; } }
    function restart() { stop(); start(); }

    var prev = root.querySelector('[data-tb-prev]');
    var next = root.querySelector('[data-tb-next]');
    if (prev) { prev.addEventListener('click', function () { show(current - 1); restart(); }); }
    if (next) { next.addEventListener('click', function () { show(current + 1); restart(); }); }

    /* glisser au doigt */
    var x0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) { return; }
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) { show(current + (dx < 0 ? 1 : -1)); restart(); }
      x0 = null;
    }, { passive: true });

    cards.forEach(function (c, k) { c.classList.toggle('is-active', k === 0); });
    show(0);
    onVisible(root, function (v) { inView = v; if (v) { start(); } else { stop(); } }, { threshold: 0.2 });
  }

  /* ----------------------------------------------------------------------
     Vidéos « la preuve » (fiche produit)
     ---------------------------------------------------------------------- */
  function initPpv(root) {
    var track = root.querySelector('.tb-ppv__track');
    var cards = $$('.tb-ppv__card', root);
    if (track) { bindTrack(root, track); }

    function load(card) {
      if (card.__tbLoaded) { return; }
      var v = card.querySelector('video');
      var src = v && v.getAttribute('data-video');
      if (!src) { return; }
      v.preload = 'auto';
      v.src = src;
      v.addEventListener('playing', function () { card.classList.add('is-playing'); });
      card.__tbLoaded = true;
    }
    function play(card) { load(card); var v = card.querySelector('video'); if (v) { safePlay(v); } }
    function pause(card) { var v = card.querySelector('video'); if (v && !v.paused) { v.pause(); } }

    if (hasIO) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { load(e.target); }
          if (e.isIntersecting && e.intersectionRatio >= 0.55) {
            if (!e.target.classList.contains('is-paused')) { play(e.target); }
          } else if (!e.isIntersecting) { pause(e.target); }
        });
      }, { threshold: [0, 0.55, 1], rootMargin: '400px 0px' });
      cards.forEach(function (c) { io.observe(c); });
    } else {
      cards.forEach(load);
    }

    cards.forEach(function (card) {
      var btn = card.querySelector('.tb-ppv__toggle');
      var v = card.querySelector('video');
      if (!btn || !v) { return; }
      v.addEventListener('play', function () { card.classList.remove('is-paused'); });
      btn.addEventListener('click', function () {
        load(card);
        if (v.paused) {
          safePlay(v);
          btn.setAttribute('aria-label', btn.getAttribute('data-label-pause') || 'Mettre en pause la vidéo');
        } else {
          v.pause();
          card.classList.add('is-paused');
          btn.setAttribute('aria-label', btn.getAttribute('data-label-play') || 'Lire la vidéo');
        }
      });
    });
  }

  /* ----------------------------------------------------------------------
     Accordéons (FAQ + produit) — un seul ouvert à la fois
     ---------------------------------------------------------------------- */
  function initAccordion(root) {
    var items = $$('[data-tb-item]', root);
    var single = root.getAttribute('data-single') !== 'false';
    items.forEach(function (item) {
      var btn = item.querySelector('[data-tb-toggle]');
      if (!btn) { return; }
      btn.setAttribute('aria-expanded', item.classList.contains('is-open') ? 'true' : 'false');
      btn.addEventListener('click', function () {
        var wasOpen = item.classList.contains('is-open');
        if (single) {
          items.forEach(function (o) {
            o.classList.remove('is-open');
            var b = o.querySelector('[data-tb-toggle]');
            if (b) { b.setAttribute('aria-expanded', 'false'); }
          });
        }
        item.classList.toggle('is-open', !wasOpen);
        btn.setAttribute('aria-expanded', !wasOpen ? 'true' : 'false');
      });
    });

    /* Données structurées FAQ (Google) générées depuis le contenu affiché */
    if (root.hasAttribute('data-tb-schema') && !document.getElementById('tb-faq-schema')) {
      var qa = items.map(function (item) {
        var q = item.querySelector('[data-tb-q]');
        var a = item.querySelector('[data-tb-a]');
        if (!q || !a) { return null; }
        return { '@type': 'Question', name: q.textContent.trim(), acceptedAnswer: { '@type': 'Answer', text: a.textContent.trim() } };
      }).filter(Boolean);
      if (qa.length) {
        var s = document.createElement('script');
        s.type = 'application/ld+json';
        s.id = 'tb-faq-schema';
        s.textContent = JSON.stringify({ '@context': 'https://schema.org', '@type': 'FAQPage', mainEntity: qa });
        document.head.appendChild(s);
      }
    }
  }

  /* ----------------------------------------------------------------------
     Code promo : copier + appliquer automatiquement au paiement
     ---------------------------------------------------------------------- */
  function initPromo(root) {
    var btn = root.querySelector('[data-tb-copy]');
    var codeEl = root.querySelector('[data-tb-code]');
    var bg = root.querySelector('.tb-promo__frame');
    if (bg) { onVisible(bg, function (v) { if (v) { bg.classList.add('is-in'); } }, { threshold: 0.2 }); }
    if (!btn || !codeEl) { return; }
    var label = btn.querySelector('[data-tb-label]') || btn;
    var original = label.textContent;
    btn.addEventListener('click', function () {
      var code = codeEl.textContent.trim();
      function done() {
        btn.classList.add('is-done');
        label.textContent = btn.getAttribute('data-done') || 'Copié ✓';
        window.setTimeout(function () { btn.classList.remove('is-done'); label.textContent = original; }, 2400);
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done, done);
      } else {
        var area = document.createElement('textarea');
        area.value = code; area.setAttribute('readonly', ''); area.style.position = 'fixed'; area.style.opacity = '0';
        document.body.appendChild(area); area.select();
        try { document.execCommand('copy'); } catch (e) {}
        document.body.removeChild(area);
        done();
      }
      /* Shopify retient le code pour le paiement (cookie) */
      if (window.fetch && btn.getAttribute('data-apply') !== 'false') {
        var root_url = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        fetch(root_url + 'discount/' + encodeURIComponent(code), { credentials: 'same-origin' }).catch(function () {});
      }
    });
  }

  /* ----------------------------------------------------------------------
     Date de livraison estimée (jours ouvrés)
     ---------------------------------------------------------------------- */
  function addBusinessDays(date, days) {
    var d = new Date(date.getTime());
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      var wd = d.getDay();
      if (wd !== 0 && wd !== 6) { added++; }
    }
    return d;
  }
  function initLive(root) {
    var min = parseInt(root.getAttribute('data-min'), 10) || 8;
    var max = parseInt(root.getAttribute('data-max'), 10) || 14;
    var lang = docEl.lang || 'fr';
    var fmt;
    try { fmt = new Intl.DateTimeFormat(lang, { weekday: 'short', day: 'numeric', month: 'short' }); }
    catch (e) { fmt = new Intl.DateTimeFormat('fr', { weekday: 'short', day: 'numeric', month: 'short' }); }
    var now = new Date();
    var out = root.querySelector('[data-tb-eta]');
    var tpl = root.getAttribute('data-template');
    if (!out || !tpl) { return; }
    var span = function (d) { return '<span class="tb-live__date">' + fmt.format(d) + '</span>'; };
    out.innerHTML = tpl
      .replace('{from}', span(addBusinessDays(now, min)))
      .replace('{to}', span(addBusinessDays(now, max)));
  }

  /* ----------------------------------------------------------------------
     Défilement vers le bouton « Ajouter au panier »
     ---------------------------------------------------------------------- */
  function findAtc() {
    return document.querySelector('product-info product-form .product-form__submit, product-form .product-form__submit, button[name="add"]');
  }
  function scrollToAtc() {
    var target = findAtc();
    if (!target) { return false; }
    var rect = target.getBoundingClientRect();
    var top = rect.top + window.pageYOffset - (window.innerHeight / 2) + (rect.height / 2);
    window.scrollTo({ top: Math.max(0, top), behavior: reduceMotion ? 'auto' : 'smooth' });
    target.classList.remove('tb-flash'); void target.offsetWidth; target.classList.add('tb-flash');
    return true;
  }
  function initScrollAtc(root) {
    root.addEventListener('click', function (e) {
      if (findAtc()) { e.preventDefault(); scrollToAtc(); }
    });
  }

  /* Note des avis → défile vers la section d'avis */
  function initTrust(root) {
    root.addEventListener('click', function (e) {
      var target = document.querySelector('#looxReviews, .loox-reviews-default, [id*="looxReviews"], [data-tb-reviews]');
      if (!target) { return; }
      e.preventDefault();
      target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    });
  }

  /* ----------------------------------------------------------------------
     Barre d'achat collante (mobile)
     ---------------------------------------------------------------------- */
  function initSticky(bar) {
    var atc = findAtc();
    if (!atc) { return; }
    var btn = bar.querySelector('.tb-sticky__btn');
    var priceOut = bar.querySelector('[data-tb-sticky-price]');
    var priceSrc = document.querySelector('[data-tb-price-src]');
    if (bar.parentElement !== document.body) { document.body.appendChild(bar); }

    function syncPrice() {
      if (!priceOut || !priceSrc) { return; }
      var now = priceSrc.querySelector('.tb-price__now');
      var was = priceSrc.querySelector('.tb-price__was');
      priceOut.innerHTML = '';
      if (now) { priceOut.appendChild(document.createTextNode(now.textContent.trim())); }
      if (was) { var s = document.createElement('s'); s.textContent = was.textContent.trim(); priceOut.appendChild(s); }
    }
    function syncState() {
      var live = findAtc();
      if (!live || !btn) { return; }
      var disabled = live.hasAttribute('disabled');
      btn.disabled = disabled;
      var span = live.querySelector('span');
      var txt = (span ? span.textContent : live.textContent).trim();
      if (txt) { btn.textContent = txt; }
    }
    syncPrice(); syncState();
    if (window.MutationObserver) {
      var target = priceSrc && priceSrc.parentElement;
      if (target) { new MutationObserver(syncPrice).observe(target, { childList: true, subtree: true, characterData: true }); }
      var form = atc.closest('form') || atc.parentElement;
      if (form) { new MutationObserver(syncState).observe(form, { attributes: true, subtree: true, childList: true, attributeFilter: ['disabled'] }); }
    }

    var footer = document.querySelector('footer, .footer');
    var atcVisible = true, footerVisible = false;
    function update() {
      var live = findAtc();
      var rect = live ? live.getBoundingClientRect() : null;
      var passed = rect ? rect.bottom < 0 : false;
      bar.classList.toggle('is-visible', !atcVisible && passed && !footerVisible);
    }
    if (hasIO) {
      new IntersectionObserver(function (es) { atcVisible = es[0].isIntersecting; update(); }).observe(atc);
      if (footer) { new IntersectionObserver(function (es) { footerVisible = es[0].isIntersecting; update(); }).observe(footer); }
      window.addEventListener('scroll', function () { raf(update); }, { passive: true });
    }
    if (btn) { btn.addEventListener('click', function () { scrollToAtc(); }); }
  }

  /* ----------------------------------------------------------------------
     Démarrage
     ---------------------------------------------------------------------- */
  var registry = {
    hero: initHero,
    vids: initVids,
    rvc: initRvc,
    rs: initReviewSlider,
    ppv: initPpv,
    accordion: initAccordion,
    promo: initPromo,
    live: initLive,
    'scroll-atc': initScrollAtc,
    trust: initTrust,
    sticky: initSticky
  };

  function boot(root) {
    root = root || document;
    docEl.classList.add('tb-ready');
    initReveal(root);
    $$('[data-tb]', root).forEach(function (el) {
      var fn = registry[el.getAttribute('data-tb')];
      if (fn && once(el, 'init')) {
        try { fn(el); } catch (err) { if (window.console) { console.warn('[tribune]', err); } }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    var id = e.detail && e.detail.sectionId;
    if (!id) { return; }
    $$('.tb-sticky[data-section-id="' + id + '"]').forEach(function (bar) {
      if (bar.parentElement === document.body) { bar.remove(); }
    });
  });
})();
